import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class ProductCategoryGroupsDialog {
  constructor($scope, $rootScope, ProductService) {
    $scope.$on('show_product_category_groups', function(event, data) {
      $scope.categories = data.categories;
      $scope.groups = [];
      $scope.selected_category = data.categories[0];
      $scope.selected_groups = angular.copy(data.selected_groups);

      $scope.load_groups();
      window.openFancyboxDialog('div#category_groups_dialog');
    });

    $scope.$on('show_product_category_specs_groups', function(event, data) {
      $scope.categories = data.categories;
      $scope.groups = [];
      $scope.selected_category = data.categories[0];
      $scope.selected_groups = angular.copy(data.selected_groups);

      $scope.load_groups();
      window.openFancyboxDialog('div#category_specs_groups_dialog');
    });

    $scope.load_groups = function() {
      ProductService.get_groups($scope.selected_category.id)
        .then(function(data) {
          _.each(data.groups, function(group) {
            var selected_group = _.findWhere($scope.selected_groups, {
              id: group.id
            });
            if (selected_group) {
              group.checked = true;
            }
          });
          $scope.groups = data.groups;
        });
    };

    $scope.update_groups = function(group) {
      if (group.checked) {
        var selected_group = _.findWhere($scope.selected_groups, {
          id: group.id
        });
        if (!selected_group) {
          $scope.selected_groups.push({
            id: group.id,
            title: group.title
          });
        }
      } else {
        $scope.selected_groups = _.reject($scope.selected_groups, function(selected_group) {
          return selected_group.id === group.id;
        });
      }
    };

    $scope.update_specs_groups = function(group) {
      if (group.checked) {
        var selected_group = _.findWhere($scope.selected_groups, {
          id: group.id
        });
        if (!selected_group) {
          $scope.selected_groups.push({
            id: group.id,
            title: group.title
          });
        }
      } else {
        $scope.selected_groups = _.reject($scope.selected_groups, function(selected_group) {
          return selected_group.id === group.id;
        });
      }
    };

    $scope.remove_group = function(group_id) {
      $scope.selected_groups = _.reject($scope.selected_groups, function(group) {
        return group.id === group_id;
      });

      var group = _.findWhere($scope.groups, {
        id: group_id
      });
      if (group) {
        group.checked = false;
      }
    };

    $scope.remove_specs_group = function(group_id) {
      $scope.selected_groups = _.reject($scope.selected_groups, function(group) {
        return group.id === group_id;
      });

      var group = _.findWhere($scope.groups, {
        id: group_id
      });
      if (group) {
        group.checked = false;
      }
    };

    $scope.submit = function() {
      var data = {
        groups: $scope.selected_groups,
      };
      $rootScope.$broadcast('product_category_groups_update', data);
      $.fancybox.close();
    };

    $scope.stocklist_spec_submit = function() {
      var data = {
        groups: $scope.selected_specs_groups,
      };
      $rootScope.$broadcast('product_category_specs_groups_update', data);
      $.fancybox.close();
    };

  }
}

ProductCategoryGroupsDialog.$inject = ['$scope', '$rootScope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-category-groups-dialog.ctrl.js